import React, { useState, useEffect } from "react";
import { SPECS_LIST, DisplayedSpecs, Specs } from "./SpecsIconModel";
import {
  ListingCategoryTypes,
  SellerListing,
} from "@/interfaces/listing/SellerListing";
import Image from "next/image";

const SpecsIcons = ({ listing }: { listing: SellerListing }) => {
  const [specs, setSpecs] = useState<DisplayedSpecs[]>([]);

  useEffect(() => {
    if (listing) {
      setSpecs(getSpecs(listing));
    }
  }, [listing]);

  const getSpecs = (listing: SellerListing): DisplayedSpecs[] => {
    let specs;
    switch (listing.vehicleType) {
      case ListingCategoryTypes.Motorcycle:
        specs = getMotorcycleSpecs();
        break;
      case ListingCategoryTypes.ATVOHV:
        specs = getATVSpecs();
        break;
      default:
        specs = getAutoSpecs();
        break;
    }
    return specs;
  };

  const getAutoSpecs = () => {
    return [
      getDisplayedSpec(SPECS_LIST.Miles),
      getDisplayedSpec(SPECS_LIST.Transmission),
      getDisplayedSpec(SPECS_LIST.InteriorColor),
      getDisplayedSpec(SPECS_LIST.Engine),
      getDisplayedSpec(SPECS_LIST.Fuel),
      getDisplayedSpec(SPECS_LIST.AutoDrive),
    ];
  };

  const getMotorcycleSpecs = () => {
    return [
      getDisplayedSpec(SPECS_LIST.Miles),
      getDisplayedSpec(SPECS_LIST.Transmission),
      getDisplayedSpec(SPECS_LIST.MotorcycleCategory),
      getDisplayedSpec(SPECS_LIST.Engine),
      getDisplayedSpec(SPECS_LIST.Fuel),
      getDisplayedSpec(SPECS_LIST.MotorcycleDrive),
    ];
  };

  const getATVSpecs = () => {
    return [
      getDisplayedSpec(SPECS_LIST.Miles),
      getDisplayedSpec(SPECS_LIST.Transmission),
      getDisplayedSpec(SPECS_LIST.ATVWeight),
      getDisplayedSpec(SPECS_LIST.Engine),
      getDisplayedSpec(SPECS_LIST.Fuel),
      getDisplayedSpec(SPECS_LIST.ATVDriveType),
    ];
  };

  const getDisplayedSpec = (spec: Specs): DisplayedSpecs => {
    const { icon, text, getter } = spec;
    const value = getter(listing) as string;
    return { icon, text, value };
  };

  return (
    <div>
      <h3 className="text-xl md:text-3xl font-bold opacity-90">Details</h3>
      <div className="wrapper bg-white text-gray-600 grid grid-cols-2 md:grid-cols-3 gap-2.5">
        {specs.map((spec, index) => (
          <div key={index} className="item flex items-center p-3 mt-3">
            <div className="flex justify-end min-w-[48px]">
              <Image
                width={spec.icon.size}
                height={spec.icon.size}
                src={spec.icon.src}
                alt="listing specs icon"
              />
            </div>
            <div className="details-text ml-4">
              <div className="value font-bold text-base">
                {spec.value || "-"}
              </div>
              <div className="name font-normal text-sm text-[#7E7E7E]">
                {spec.text}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecsIcons;
